import { useEventBus } from '@vueuse/core'

export interface AppScrollPayload {
  scrollTop: number
  scrollLeft: number
  direction: 'up' | 'down' | 'left' | 'right' | 'none'
  event?: Event
}

const BUS_KEY = 'app:scroll'

export function useAppScrollBus() {
  const bus = useEventBus<AppScrollPayload>(BUS_KEY)

  const emitScroll = (payload: AppScrollPayload) => {
    bus.emit(payload)
  }

  const onScroll = (callback: (payload: AppScrollPayload) => void) => {
    const off = bus.on(callback)
    return off
  }

  return { emitScroll, onScroll }
}
